<mat-select
  [value]="internalControlValue()"
  (valueChange)="onInternalChange($event)"
  [disabled]="internalControlDisabled()"
>
  @for (opt of timeOptions(); track opt.dayMinute) {
    <mat-option [value]="opt.dayMinute">{{ opt.displayText }}</mat-option>
  }
</mat-select>
